import { useSelector } from 'react-redux';
import { getHondaExpApiUrl, getHondaExpApiHeaders } from '@honda-canada/js-utilities/lib/hondaExpApi';
import useSotHondaExpApiConfig from '../../utils/sitecoreContext/useSotHondaExpApiConfig';
import { useLanguage } from '../../utils/sitecoreContext';
import { useGetDealerStatusQuery } from '../apis/dealerApi';
import { selectDealer } from '../reducers/dealer';
var useFetchDealer = function () {
    var config = useSotHondaExpApiConfig();
    var language = useLanguage();
    var env = config.env, consumerId = config.consumerId, consumerName = config.consumerName;
    var headers = getHondaExpApiHeaders({ consumerName: consumerName, consumerId: consumerId, language: language });
    var dealerCode = useSelector(selectDealer).dealerCode;
    var url = getHondaExpApiUrl({
        env: env,
        consumerName: consumerName,
    });
    var _a = useGetDealerStatusQuery({
        url: "".concat(url, "/dealers/").concat(dealerCode, "/hours"),
        headers: headers,
        params: { dealerCode: dealerCode },
    }, { skip: !dealerCode }), data = _a.data, isFetching = _a.isFetching, isLoading = _a.isLoading, error = _a.error;
    return { data: data, isFetching: isFetching, isLoading: isLoading, error: error };
};
export default useFetchDealer;
